
import InfoBoxComponent from '@/components/Shared/ViewResultCard/InfoBox/InfoBoxComponent';
export default InfoBoxComponent;
